<template>
    <div id="novel_list">
        <img v-if="!searchResult" src="@/assets/image/home/dj_empty.png"
            style="object-fit: cover;height: 100%;width: 100%;cursor: pointer;border-radius: 10px;"
            @click="toCreate('add')" />
        <div class="novel_list" v-if="searchResult">
            <div class="flex-row">
                <div class="novel_list1 cursor_1" @click="toHome">
                    <img src="@/assets/image/icon_right.png" alt="">
                    短剧作品列表
                </div>
                <!-- <div class="t-m-l-20">
                    <el-button type="text" class="novel_list2 " v-if="novelList.length > 0">
                        <span @click="openEditor" v-if="isEdit">管理</span>
                        <span @click="openEditor" v-if="!isEdit">取消</span>
                    </el-button>
                </div> -->

            </div>
            <div class="flex-row" :class="!isEdit ? 'noEditor_pointer' : ''">
                <!-- <el-radio-group v-model="status" class="t-m-r-20" style="display: flex;user-select: none;"
					@input="statusChang">
					<el-radio-button label="">全部</el-radio-button>
					<el-radio-button label="0">连载</el-radio-button>
					<el-radio-button label="1">完结</el-radio-button>
				</el-radio-group>
				<el-radio-group v-model="length" class="t-m-r-20" style="display: flex;user-select: none;"
					@input="lengthChang">
					<el-radio-button label="长篇">长篇</el-radio-button>
					<el-radio-button label="中篇">中篇</el-radio-button>
					<el-radio-button label="短篇">短篇</el-radio-button>
				</el-radio-group> -->
                <!-- <el-input placeholder="请输入作品名称" v-model="query" class="novel_input-with-select t-m-l-15 t-m-r-20"
					@keyup.enter.native="selectClick">
					<i class="el-icon-search el-input__icon cursor_1" :style="{ pointerEvents: !isEdit ? 'none' : '' }"
						slot="suffix" @click="selectClick">
					</i>
				</el-input> -->
                <el-button type="primary" @click="toCreate('add')" class="novel_list2">
                    <span class="el-icon-plus" style="font-weight: bold;"></span>
                    <span>创建新作品</span>
                </el-button>
                <!-- <div class="novel_list2 cursor_1 shrink-0 t-m-l-20" >

				</div>
				<div class="novel_list2 cursor_1 shrink-0 t-m-l-20" @click="toCreate">
					管理
				</div> -->
            </div>

        </div>
        <!-- <div class="novel_list3" v-if="!searchResult">
            <noData :noIndex="1" @toCreate="toCreate" v-if="!query"></noData>
        </div> -->
        <div class="novel_list3" v-if="searchResult">
            <div v-if="!isEdit" class="selectBtn">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
                    @change="handleCheckAllChange">全选</el-checkbox>
                <el-button type="text" @click="batchDel" style="margin-left: 20px;">删除</el-button>
            </div>
            <div class="item">
                <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                    <div class="novel_list4" v-for="(item, i) in novelList" :key="i" @click.stop="nextStep(i, 0)">
                        <el-checkbox :label="item.id" v-if="!isEdit" class="no-label"></el-checkbox>
                        <div style="position: relative;width: 100px;height: 133px;flex-shrink: 0;border-radius: 8px;">
                            <img class="novel_list5" style="object-fit: cover;" :src="item.img" alt=""
                                @click.stop="nextStep(i, 1)">
                        </div>

                        <div class="novel_list6">
                            <div class="novel_list7">{{ item.name }}</div>
                            <div class="novel_list8">
                                <span style="margin-right: 10px;">{{ item.status == 0 ? '连载中' : '已完结' }} {{
                                    item.totalNumber }}</span>
                            </div>
                            <div class="novel_list8">{{ item.episodes }}</div>
                            <div class="novel_list9" style="justify-content: flex-end;">
                                <div class="novel_list10">{{ item.createTime }} </div>

                                <!-- <div class="novel_list10"><span>最近更新时间：</span>{{ item.lastUpdate }}<span
                                        class="t-m-l-20 novel_time_text" v-if="item.lastUpdateTime">{{
                                            item.lastUpdateTime
                                        }}更新</span>
                                </div> -->
                                <div class="novel_list11 noBorderArray">
                                    <!-- <div class="novel_list12 cursor_1 btn_item" v-for="(items, l) in scriptListIcon" :key="l"
                                        @click.stop="nextStep(i, l)"
                                        @mouseenter="() => { selectedIndex = l; selectedId = item.id }"
                                        @mouseleave="() => { selectedIndex = -1; selectedId = '' }">
                                        <img :src="items.icon" alt="">
                                        <span>{{ items.title }}</span>
                                    </div> -->
                                    <template v-for="(items, l) in scriptListIcon">
                                        <el-tooltip popper-class="novel_toolTip"
                                            :disabled="Object.hasOwn(items, 'title') ? false : true" :key="l"
                                            placement="top" effect="light" :content="items.title">
                                            <div class="novel_list12 cursor_1 btn_item" @click.stop="nextStep(i, l)"
                                                @mouseenter="() => { selectedIndex = l; selectedId = item.id }"
                                                @mouseleave="() => { selectedIndex = -1; selectedId = '' }">
                                                <img class="t-m-r-5"
                                                    :src="selectedIndex === l && selectedId == item.id ? items.icon : items.uIcon"
                                                    alt="">
                                                <span>{{ items.name }}</span>
                                            </div>
                                        </el-tooltip>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-checkbox-group>
            </div>
        </div>

        <bottomPage v-show="total" :total="total" @currentNUm="currentNUm" :pageSize="this.pageSize" ref="bottompage">
        </bottomPage>
        <delPopup ref="delPopup" @confirm="confirmDel"></delPopup>
    </div>
</template>

<script>
import data from '@/assets/data';
import noData from '@/components/no_data.vue';
import delPopup from '@/components/del_popup.vue';
import bottomPage from '@/components/bottom_page.vue' //底部分页
import SApi from '@/api/script'
import api from '@/api/api'
import { EncryptionUtil } from '@/utils/encrypt'
export default {
    components: {
        noData, delPopup, bottomPage
    },
    data() {
        return {
            scriptListIcon: data.scriptListIcon,//作品编辑
            delId: null, //删除id
            query: '',//搜索关键字
            status: '',// 空是全部，连载状态(0连载中 1已完结)
            length: '',//篇幅设定
            isEdit: true,//默认true不编辑，true编辑
            checkAll: false,
            checkedCount: 0,//选中状态
            checkedCities: [],
            isIndeterminate: false,
            novelList: [],
            searchResult: true,
            pageNum: 1,
            pageSize: 10,
            total: 0,
        }
    },
    created() {
        let cache = JSON.parse(localStorage.getItem(this.dSearchKey))
        console.log('获取本地缓存=', cache)
        Object.assign(this.$data, cache)
        this.init()
    },
    mounted() {
        if (this.$refs.bottompage) {
            setTimeout(() => {
                this.$refs.bottompage.page(this.pageNum)
            }, 200);
        }
    },
    methods: {
        init() {
            this.getScriptList()
        },
        getScriptList() {
            let data = { pageNum: this.pageNum, pageSize: this.pageSize }
            SApi.scriptListV2({ ...data, pageNum: 1 }).then(result => {
                //先去请求总数，去计算是在当前页还是上一页
                let total = result.total
                const maxPage = Math.ceil(total / this.pageSize)
                this.pageNum = Math.min(this.pageNum, maxPage ? maxPage : 1)
                console.log('this.pageNum=', this.pageNum)
                data.pageNum = this.pageNum
                localStorage.setItem(this.dSearchKey, JSON.stringify(data))
                SApi.scriptListV2(data).then(res => {
                    if (res.code === 200) {
                        this.novelList = res.rows
                        this.total = res.total
                        this.searchResult = this.novelList.length > 0 ? true : false
                    } else {
                        this.total = 0
                        this.searchResult = false
                    }
                })
            })
        },
        //搜索
        selectClick() {
            // this.$emit('search', { query: this.query, status: this.status, length: this.length })
            // this.$emit('search')
        },
        //失去焦点触发
        blurClick() {
            if (!this.query.trim()) {
                this.selectClick()
            }
        },
        statusSelectChange(e) {
            this.selectClick()
        },
        lengthSelectChange(e) {
            this.selectClick()
        },
        //状态选择
        statusChang(e) {
            console.log('状态值选中=', e)
            this.selectClick()
        },
        lengthChang() {
            this.selectClick()
        },
        toHome() {
            this.$router.push({ path: '/' });
        },
        //去创作
        toCreate(type, novelId = '') {
            // this.$refs.lengthSetting.open(type, novelId)
            // this.$emit('toCreate')
            this.$router.push({ path: '/scriptCreate' })
        },
        //批量删除
        batchDel() {
            if (!this.checkedCities.length) {
                this.$message.warning('请选择要删除的作品')
                return
            }
            this.$refs.delPopup.openPrompt(0, true)
        },
        //0章节管理 1编辑大纲 2作品信息 3作品下载 4作品克隆 4作品删除
        nextStep(i, l) {

            //表示这些都需要大纲判断，没有大纲就进入选择生成大纲的界面
            if ([0, 1, 2, 3].includes(l)) {
                // 有大纲就走这里
                if (this.novelList[i].thereAnOutline) {
                    //章节管理
                    if (l == 0) {
                        localStorage.removeItem(this.getChapterSearchKey(this.dChapterSearchKey, this.novelList[i].id))
                        this.$router.push({ path: '/scripChaptertList', query: { novelInfo: EncryptionUtil.encrypt(this.novelList[i]), successNovelId: this.novelList[i].id } })
                        return
                    }
                    //编辑大纲
                    if (l == 1) {
                        //编辑大纲
                        let editItem = {
                            id: this.novelList[i].id,
                            novelInfo: this.novelList[i],
                            editType: 3,
                            backNum: 1,
                        }
                        //编辑大纲 加入到缓存
                        sessionStorage.setItem('editItem', JSON.stringify(editItem))
                        this.$router.push({ path: '/scriptOutline' })
                    }
                    //作品信息
                    if (l == 2) {
                        this.$router.push({ path: '/scriptInfo', query: { novelInfo: EncryptionUtil.encrypt(this.novelList[i]), successNovelId: this.novelList[i].id } })
                        return
                    }
                    //作品小载
                    if (l == 3) {
                        SApi.downloadText({ scriptId: this.novelList[i].id }).then((res) => {
                            let downloadInfo = this.saveTextToFile(res, this.novelList[i])
                            this.saveToLocalStorage(downloadInfo)
                        })
                        return
                    }
                }
                //没有章纲走其他地方
                else {
                    this.$router.push({ path: '/scriptSuccess', query: { novelInfo: EncryptionUtil.encrypt(this.novelList[i]), successNovelId: this.novelList[i].id } })
                }
            } else {
                //表示都不需要经过是否有大纲进行判断
                //作品克弄
                if (l == 4) {
                    this.$router.push({ path: '/scriptInfo', query: { novelInfo: EncryptionUtil.encrypt(this.novelList[i]), successNovelId: this.novelList[i].id, copy: true } })
                    return
                }
                //删除
                if (l == 5) {
                    // this.$refs.delPopup.openPrompt(0)
                    this.$confirm('删除后将无法恢复，请谨慎操作?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.delId = i
                        SApi.delAllScript({
                            ids: this.novelList[i].id
                        }).then((res) => {
                            if (res.code == 200) {
                                this.$message.success('删除成功！')
                                this.init()
                            } else {
                                this.$message.warning(res.msg)
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                    return
                }
            }

        },
        saveTextToFile(text, novel) {
            const now = new Date();
            const timestamp = now.toISOString().replace(/[:.]/g, '-');
            const fileName = `${novel.name}_${timestamp}.txt`;
            const element = document.createElement('a');
            const file = new Blob([text], { type: 'text/plain' });
            element.href = URL.createObjectURL(file);
            element.download = fileName;
            element.click();
            URL.revokeObjectURL(element.href);
            return {
                fileName,
                downloadTime: now.toISOString(),
            };
        },
        saveToLocalStorage(downloadInfo) {
            let novelDownload = JSON.parse(localStorage.getItem('novelDownload')) || [];
            novelDownload.push(downloadInfo);
            localStorage.setItem('novelDownload', JSON.stringify(novelDownload));
        },
        //数据初始化
        initData() {
            this.isEdit = true
            this.checkedCities = []
            this.checkAll = false
            this.indeterminate = false
            this.checkedCount = 0
        },
        //确认删除
        confirmDel(isAllDel) {
            if (isAllDel) {
                // console.log(this.checkedCities.join(','))
                SApi.delAllScript({ ids: this.checkedCities }).then((res) => {
                    if (res.code == 200) {
                        this.$message.success('删除成功！')
                        this.initData()
                        this.init()
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
            } else {
                SApi.delAllScript({ ids: [this.novelList[this.delId].id] }).then((res) => {
                    if (res.code == 200) {
                        this.$message.success('删除成功！')
                        // this.novelList.splice(this.delId, 1)
                        this.init()
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
            }

        },
        openEditor() {
            this.isEdit = !this.isEdit
            //如果取消，就取消勾选
            if (this.isEdit) {
                this.initData()
            }
        },
        handleCheckAllChange(val) {
            this.checkedCities = val ? this.novelList.map(item => item.id) : [];
            this.isIndeterminate = false;
            // console.log('全选事件=', val)
        },
        handleCheckedCitiesChange(value) {
            this.checkedCount = value.length;
            this.checkAll = this.checkedCount === this.novelList.length;
            this.isIndeterminate = this.checkedCount > 0 && checkedCount < this.novelList.length;
            // console.log('选中事件=', value)
        },
        //分页下一页
        currentNUm(pageNum) {
            this.pageNum = pageNum
            //分页记录缓存
            this.init()
        },
    }
}
</script>

<style lang="scss" scoped>
/*  */
.novel_input-with-select {
    width: 300px;
    background-color: #FFFFFF !important;

    ::v-deep(.el-input__inner) {
        width: 100% !important;
        background-color: #FFFFFF !important;

        &::placeholder {
            color: #aaa;
        }
    }
}

.search_select {

    ::v-deep(.el-input__inner) {
        width: 100% !important;
        background-color: #FFFFFF !important;

        &::placeholder {
            color: #aaa;
        }
    }
}

.novel_input-with-select .el-icon-search {
    font-size: 120% !important;
}

.novel_input-with-select>.el-input__inner {
    background-color: #FFFFFF !important;
    width: 300px !important;
}

#novel_list {
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
    box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
}

.novel_list {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    height: 77px;
    justify-content: space-between;
    border-bottom: 1px solid #E6EBF0;
    padding: 0 25px;
}

.novel_list1 {
    font-weight: bold;
    font-size: 19px;
    color: #111111;
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.novel_list1 img {
    width: 23px;
    height: 23px;
    margin-right: 5px;
}

.no-label {
    padding-right: 20px !important;

    ::v-deep .el-checkbox__label {
        display: none !important;
    }
}



/* .novel_list2 {
	width: 110px;
	height: 21px;
	background: url('../assets/image/icon_list.png') no-repeat;
	background-size: 21px 21px;
	background-position: left center;
	padding-left: 25px;
	font-size: 17px;
	color: var(--tech-primary);
	line-height: 21px;
} */

.novel_list2 {
    height: 40px;

    span {
        font-size: 17px;
    }
}

/* .novel_list2:hover {
	background: url('../assets/image/icon_list1.png') no-repeat;
	background-size: 21px 21px;
	color: var(--tech-primary);
} */

.novel_list3 {
    flex: 1;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;
}

.novel_list3 .selectBtn {
    flex-shrink: 0;
    height: 50px;
    line-height: 50px;
    padding: 0 25px;
}

.novel_list3 .item {
    flex: 1;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.novel_list4 {
    display: flex;
    margin: 0 25px;
    padding: 21px 0;
    border-bottom: 1px solid #E6EBF0;
}

.novel_list5 {
    width: 100%;
    height: 100%;
    display: block;
    border-radius: 8px;
    flex-shrink: 0;
}

.length_text {
    position: absolute;
    display: block;
    font-size: 15px;
    text-align: center;
    top: 0;
    left: 0;
    width: 40px;
    /* 长方形的宽度 */
    height: 24px;
    /* 形状颜色 */
    border-top-left-radius: 6px;
    /* 左上角与父 div 圆角一致 */
    border-bottom-right-radius: 12px;
    /* 右侧弧度 */

    &.long {
        background: #FF6603;
        color: #fff;
    }

    &.duan {
        background: #00CF9B;
        color: #fff;
    }

    &.zhong {
        background: #548AFF;
        color: #fff;
    }
}

.novel_list6 {
    flex: 1;
    height: 133px;
    margin-left: 10px;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
}

.novel_list7 {
    font-weight: bold;
    font-size: 18px;
    color: #111111;
}

.novel_list8 {
    font-size: 16px;
    color: #333333;
}

.novel_list9 {
    width: 100%;
    display: flex;
    justify-content: space-between !important;
}

.novel_time_text {
    color: var(--tech-primary);
}

.novel_list10 {
    font-size: 14px;
    color: #666666;
}

.novel_list11 {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    align-items: center;
    width: 500px;
}

.novel_list12 {
    display: flex;
    align-items: center;
    font-size: 15px;
    color: #333333;

    .sc {
        color: var(--tech-primary);
    }
}

.novel_list12:hover {
    color: var(--tech-primary);
}

.novel_list12 img {
    width: 16px;
    height: 16px;
    margin-right: 5px;
}
</style>